<template>
  <div v-if="url || deeplink || actionTypeLabel" class="preview-default-action">
    <div
      class="preview-default-action__title"
      :data-qa="`${dataQaPrefix}-default-action-title`"
    >
      {{ $t('CampaignForm_Preview_Push_DefaultActionTitle') }}
    </div>
    <div
      v-if="url"
      class="preview-default-action__row"
      :data-qa="`${dataQaPrefix}-default-action-url`"
    >
      <span class="preview-default-action__label">{{
        $t('CampaignForm_Push_DefaultAction_Url')
      }}</span>
      <a
        v-if="isSafeHttpUrl(url)"
        :href="url"
        target="_blank"
        rel="noopener noreferrer"
        class="preview-default-action__value preview-default-action__link"
        :data-qa="`${dataQaPrefix}-default-action-url-link`"
      >
        {{ url }}
      </a>
      <span
        v-else
        class="preview-default-action__value"
        :data-qa="`${dataQaPrefix}-default-action-url-value`"
      >
        {{ url }}
      </span>
    </div>
    <div
      v-if="deeplink"
      class="preview-default-action__row"
      :data-qa="`${dataQaPrefix}-default-action-deeplink`"
    >
      <span class="preview-default-action__label">{{
        $t('CampaignForm_Push_DefaultAction_Deeplink')
      }}</span>
      <span
        class="preview-default-action__value"
        :data-qa="`${dataQaPrefix}-default-action-deeplink-value`"
      >
        {{ deeplink }}
      </span>
    </div>
    <div
      v-if="actionTypeLabel"
      class="preview-default-action__row"
      :data-qa="`${dataQaPrefix}-default-action-type`"
    >
      <span class="preview-default-action__label">{{ actionTypeLabel }}</span>
    </div>
  </div>
</template>

<script>
import { isSafeHttpUrl } from '@/core/helpers'

export default {
  name: 'PreviewDefaultAction',
  props: {
    url: {
      type: String,
      default: ''
    },
    deeplink: {
      type: String,
      default: ''
    },
    dataQaPrefix: {
      type: String,
      required: true
    },
    actionType: {
      type: String,
      default: null
    }
  },
  computed: {
    actionTypeLabel() {
      const map = {
        dismiss: this.$t('CampaignForm_InApp_Action_Dismiss'),
        inapp: this.$t('CampaignForm_Push_DefaultAction_InAppMessage')
      }
      return map[this.actionType] || null
    }
  },
  methods: {
    isSafeHttpUrl
  }
}
</script>

<style scoped>
.preview-default-action__title {
  font-size: 13px;
  font-weight: 700;
  color: #303133;
  margin-top: 0;
  margin-bottom: 8px;
}

.preview-default-action__row {
  display: flex;
  flex-direction: row;
  gap: 8px;
  word-break: break-all;
}

.preview-default-action__label {
  font-weight: 600;
  flex-shrink: 0;
}

.preview-default-action__value {
  word-break: break-all;
  min-width: 0;
}

.preview-default-action__link {
  color: #409eff;
  text-decoration: none;
}

.preview-default-action__link:hover {
  text-decoration: underline;
}

.preview-default-action {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/PreviewDefaultAction.vue